import { GET_ACCACCOUNTCLOSE, GET_ACCACCOUNTCLOSE_SUCCESS, GET_ACCACCOUNTCLOSE_FAIL, DELETE_ACCACCOUNTCLOSE, DELETE_ACCACCOUNTCLOSE_SUCCESS, DELETE_ACCACCOUNTCLOSE_FAIL, UPDATE_ACCACCOUNTCLOSE, UPDATE_ACCACCOUNTCLOSE_SUCCESS, UPDATE_ACCACCOUNTCLOSE_FAIL, ADD_NEW_ACCACCOUNTCLOSE, ADD_ACCACCOUNTCLOSE_SUCCESS, ADD_ACCACCOUNTCLOSE_FAIL, ACCACCOUNTCLOSE_LOADING, ACCACCOUNTCLOSE_RESET, ACCACCOUNTCLOSE_RESET_CREATE } from "./actionType";

export const resetAccAccountCloseState = (actionType) => ({
  type: ACCACCOUNTCLOSE_RESET,
  payload: { actionType },
});

export const resetAccAccountCloseCreateState = (actionType) => ({
  type: ACCACCOUNTCLOSE_RESET_CREATE,
  payload: { actionType },
});

export const getAccAccountCloseSuccess = (actionType, data) => ({
  type: GET_ACCACCOUNTCLOSE_SUCCESS,
  payload: { actionType, data },
});

export const getAccAccountCloseFail = (actionType, error) => ({
  type: GET_ACCACCOUNTCLOSE_FAIL,
  payload: { actionType, error },
});

export const getAccAccountClose = (data) => ({
  type: GET_ACCACCOUNTCLOSE,
  payload: data,
});

export const getAccAccountCloseLoading = () => ({
  type: ACCACCOUNTCLOSE_LOADING,
});

export const deleteAccAccountClose = (data) => ({
  type: DELETE_ACCACCOUNTCLOSE,
  payload: data,
});

export const deleteAccAccountCloseSuccess = (data) => ({
  type: DELETE_ACCACCOUNTCLOSE_SUCCESS,
  payload: data,
});

export const deleteAccAccountCloseFail = (error) => ({
  type: DELETE_ACCACCOUNTCLOSE_FAIL,
  payload: error,
});

export const updateAccAccountClose = (data) => ({
  type: UPDATE_ACCACCOUNTCLOSE,
  payload: data,
});

export const updateAccAccountCloseFail = (error) => ({
  type: UPDATE_ACCACCOUNTCLOSE_FAIL,
  payload: error,
});

export const updateAccAccountCloseSuccess = (data) => ({
  type: UPDATE_ACCACCOUNTCLOSE_SUCCESS,
  payload: data,
});

export const addNewAccAccountClose = (data) => ({
  type: ADD_NEW_ACCACCOUNTCLOSE,
  payload: data,
});

export const addAccAccountCloseSuccess = (data) => ({
  type: ADD_ACCACCOUNTCLOSE_SUCCESS,
  payload: data,
});

export const addAccAccountCloseFail = (error) => ({
  type: ADD_ACCACCOUNTCLOSE_FAIL,
  payload: error,
});
